import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat/interactiveSurvey';
import ChatInteractiveSurveyAdditionalData from 'components/chat/interactiveSurvey/AdditionalData';
import { sortAdditionalDataList } from 'reducers/chat/interactiveSurvey';

const container = connect(
  state => {
    let interactiveSurvey = state.chat.interactiveSurvey;

    return {
      caseNumber: state.chat.main.validationResult.caseNumber,
      surveySuccessfullySavedMessage: interactiveSurvey.surveyInformation.surveySuccessfullySavedMessage,
      errorSavingSurveyMessage: interactiveSurvey.surveyInformation.errorSavingSurveyMessage,
      surveyTextFooter: interactiveSurvey.surveyInformation.textFooter,
      dataMandatoryMessage: interactiveSurvey.surveyInformation.dataMandatoryMessage,
      mustSelectanOptionMessage: interactiveSurvey.surveyInformation.mustSelectanOptionMessage,
      currentAdditionalDataIndex: interactiveSurvey.currentAdditionalDataIndex,
      answered: interactiveSurvey.answers,
      nextAdditionalData: interactiveSurvey.surveyInformation.surveyAdditionalDataLists.sort(sortAdditionalDataList)[interactiveSurvey.currentAdditionalDataIndex + 1],
    };
  },
  dispatch => bindActionCreators({
    onAnswer: actions.answerAdditionalData,
    onSubmit: actions.submit,
  }, dispatch)
)(ChatInteractiveSurveyAdditionalData);

export default container;



// WEBPACK FOOTER //
// ./containers/chat/interactiveSurvey/AdditionalData.js